import Rest from '@/services/Rest';

export default class WatchService extends Rest {
  static resource = 'watch';
}
